import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import BatchForm from "containers/admin/clients/client/approval-queue/batch-details/components/batch-form/batch-form";

import { BATCH_FORM_VALIDATION_SCHEMA } from "containers/admin/clients/client/approval-queue/batch-details/components/batch-form/batch-form.consts";

export type BatchFormValues = {
  name?: string;
  description?: string;
  dueDate?: string;
  mondayBoardLink?: string;
};

type BatchFormDialogProps = {
  headline: string;
  defaultValues: BatchFormValues;
  onSubmit: (values: BatchFormValues) => void | Promise<unknown>;
  onClose: () => void;
  submitButtonText?: string;
  submitLoadingMessage?: string;
};

/** Create and edit share the batch form; mount it only while open, so each open starts from `defaultValues`. */
export const BatchFormDialog = ({
  headline,
  defaultValues,
  onSubmit,
  onClose,
  submitButtonText = "Submit",
  submitLoadingMessage,
}: BatchFormDialogProps) => {
  const form = useForm<BatchFormValues>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues,
    resolver: BATCH_FORM_VALIDATION_SCHEMA,
  });

  return (
    <FormDialog
      open
      onClose={onClose}
      headline={headline}
      form={form}
      onSubmit={onSubmit}
      submitButtonText={submitButtonText}
      submitLoadingMessage={submitLoadingMessage}>
      <BatchForm />
    </FormDialog>
  );
};
